/**
 * Snapshot of the struct_type table used by the simulated tutorial, shaped
 * like the /api/struct/type response so it can go through StructTypeFactory.
 * The tutorial runs with no network, so it cannot rely on the API.
 */
export const TUTORIAL_STRUCT_TYPES = [
  {
    "id": 1,
    "type": "Command Ship",
    "category": "fleet",
    "build_limit": 1,
    "build_difficulty": 200,
    "build_draw_p": 50000,
    "max_health": 6,
    "passive_draw_p": 50000,
    "possible_ambit": 30,
    "movable": true,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 3,
    "primary_weapon_ambits": 32,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "strongCounterAttack",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 3,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 2,
    "counter_attack_same_ambit": 2,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": true,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"space\", \"air\", \"land\", \"water\"]",
    "class": "Command Ship",
    "class_abbreviation": "CMD Ship",
    "default_cosmetic_model_number": "ST-21",
    "default_cosmetic_name": "Spearpoint",
    "build_draw": 50,
    "passive_draw": 50,
    "is_command": true,
    "primary_weapon_ambits_array": "[\"local\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "Chimera Missile",
    "primary_weapon_description": "Only targets Structs in the same battleground.",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "Alpha Drift",
    "drive_description": "Move the CMD Ship to another battleground.",
    "passive_weaponry_label": "Chimera Counter",
    "passive_weaponry_description": "Only targets Structs in the same Battleground.",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 2,
    "type": "Battleship",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 765,
    "build_draw_p": 135000,
    "max_health": 3,
    "passive_draw_p": 135000,
    "possible_ambit": 16,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "unguidedWeaponry",
    "primary_weapon_control": "unguided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 6,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "guidedWeaponry",
    "secondary_weapon_control": "guided",
    "secondary_weapon_charge": 5,
    "secondary_weapon_ambits": 16,
    "secondary_weapon_targets": 1,
    "secondary_weapon_shots": 1,
    "secondary_weapon_damage": 2,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 1,
    "secondary_weapon_shot_success_rate_denominator": 1,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "signalJamming",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 2,
    "guided_defensive_success_rate_denominator": 3,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"space\"]",
    "class": "Battleship",
    "class_abbreviation": "Battleship",
    "default_cosmetic_model_number": "CT-C",
    "default_cosmetic_name": "Cataclysm",
    "build_draw": 135,
    "passive_draw": 135,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"land\", \"water\"]",
    "secondary_weapon_ambits_array": "[\"space\"]",
    "unit_description": "",
    "primary_weapon_label": "Mass Accelerator",
    "primary_weapon_description": "",
    "primary_weapon_class": "Ballistic Weapon",
    "secondary_weapon_label": "Plasma Missile",
    "secondary_weapon_class": "Smart Weapon",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Signal Jamming",
    "unit_defenses_description": "Has a 1/3 chance to deflect incoming Smart Weapon attacks.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": true,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 3,
    "type": "Starfighter",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 250,
    "build_draw_p": 100000,
    "max_health": 3,
    "passive_draw_p": 100000,
    "possible_ambit": 16,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 3,
    "primary_weapon_ambits": 16,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "attackRun",
    "secondary_weapon_control": "unguided",
    "secondary_weapon_charge": 5,
    "secondary_weapon_ambits": 16,
    "secondary_weapon_targets": 1,
    "secondary_weapon_shots": 3,
    "secondary_weapon_damage": 1,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 1,
    "secondary_weapon_shot_success_rate_denominator": 3,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"space\"]",
    "class": "Starfighter",
    "class_abbreviation": "Starfighter",
    "default_cosmetic_model_number": "GB-1",
    "default_cosmetic_name": "Gambit",
    "build_draw": 100,
    "passive_draw": 100,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"space\"]",
    "secondary_weapon_ambits_array": "[\"space\"]",
    "unit_description": "",
    "primary_weapon_label": "Plasma Missile",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "Attack Run",
    "secondary_weapon_class": "Ballistic Weapon",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 4,
    "type": "Frigate",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 450,
    "build_draw_p": 75000,
    "max_health": 3,
    "passive_draw_p": 75000,
    "possible_ambit": 16,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 24,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"space\"]",
    "class": "Frigate",
    "class_abbreviation": "Frigate",
    "default_cosmetic_model_number": "SK-4",
    "default_cosmetic_name": "Skylight",
    "build_draw": 75,
    "passive_draw": 75,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"space\", \"air\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "RPTR Missile",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 5,
    "type": "Pursuit Fighter",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 215,
    "build_draw_p": 60000,
    "max_health": 3,
    "passive_draw_p": 60000,
    "possible_ambit": 8,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 3,
    "primary_weapon_ambits": 8,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "signalJamming",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 2,
    "guided_defensive_success_rate_denominator": 3,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"air\"]",
    "class": "Pursuit Fighter",
    "class_abbreviation": "Pursuit Fighter",
    "default_cosmetic_model_number": "SQ-11",
    "default_cosmetic_name": "Squall",
    "build_draw": 60,
    "passive_draw": 60,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"air\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "Cloudstrike Missile",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Signal Jamming",
    "unit_defenses_description": "Has a 1/3 chance to deflect incoming Smart Weapon attacks.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 6,
    "type": "Stealth Bomber",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 455,
    "build_draw_p": 125000,
    "max_health": 3,
    "passive_draw_p": 125000,
    "possible_ambit": 8,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 6,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "stealthMode",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 2,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": true,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"air\"]",
    "class": "Stealth Bomber",
    "class_abbreviation": "Stealth Bomber",
    "default_cosmetic_model_number": "RT-4",
    "default_cosmetic_name": "Rolling Thunder",
    "build_draw": 125,
    "passive_draw": 125,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"land\", \"water\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "Plasma Bomb",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Stealth Mode",
    "unit_defenses_description": "When active, this Struct can only be targeted by units in the same battleground.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 7,
    "type": "High Altitude Interceptor",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 460,
    "build_draw_p": 125000,
    "max_health": 3,
    "passive_draw_p": 125000,
    "possible_ambit": 8,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 24,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "defensiveManeuver",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 2,
    "unguided_defensive_success_rate_denominator": 3,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"air\"]",
    "class": "High Altitude Interceptor",
    "class_abbreviation": "Interceptor",
    "default_cosmetic_model_number": "SKMR",
    "default_cosmetic_name": "Skimmer",
    "build_draw": 125,
    "passive_draw": 125,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"space\", \"air\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "RPTR Missile",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Kinetic Shield",
    "unit_defenses_description": "Has a 1/3 chance to deflect incoming Ballistic Weapon attacks.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 8,
    "type": "Mobile Artillery",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 305,
    "build_draw_p": 75000,
    "max_health": 3,
    "passive_draw_p": 75000,
    "possible_ambit": 4,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "unguidedWeaponry",
    "primary_weapon_control": "unguided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 6,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "indirectCombatModule",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": false,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"land\"]",
    "class": "Mobile Artillery",
    "class_abbreviation": "Mobile Artillery",
    "default_cosmetic_model_number": "AC-4",
    "default_cosmetic_name": "Archer",
    "build_draw": 75,
    "passive_draw": 75,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"land\", \"water\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "Artillery Strike",
    "primary_weapon_description": "",
    "primary_weapon_class": "Ballistic Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Tactical Retreat",
    "unit_defenses_description": "This Struct cannot be counter-attacked, but also cannot launch counter-attacks.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 9,
    "type": "Tank",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 220,
    "build_draw_p": 75000,
    "max_health": 3,
    "passive_draw_p": 75000,
    "possible_ambit": 4,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "unguidedWeaponry",
    "primary_weapon_control": "unguided",
    "primary_weapon_charge": 3,
    "primary_weapon_ambits": 4,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "armour",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 1,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"land\"]",
    "class": "Tank",
    "class_abbreviation": "Tank",
    "default_cosmetic_model_number": "BR-9",
    "default_cosmetic_name": "Breakaway",
    "build_draw": 75,
    "passive_draw": 75,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"land\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "Rail Gun",
    "primary_weapon_description": "",
    "primary_weapon_class": "Ballistic Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Ablative Armour",
    "unit_defenses_description": "Reduces direct attack DMG by 1.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 10,
    "type": "SAM Launcher",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 450,
    "build_draw_p": 75000,
    "max_health": 3,
    "passive_draw_p": 75000,
    "possible_ambit": 4,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 24,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"land\"]",
    "class": "SAM Launcher",
    "class_abbreviation": "SAM Launcher",
    "default_cosmetic_model_number": "LG-5",
    "default_cosmetic_name": "Longshot",
    "build_draw": 75,
    "passive_draw": 75,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"space\", \"air\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "RPTR Missile",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 11,
    "type": "Cruiser",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 515,
    "build_draw_p": 110000,
    "max_health": 3,
    "passive_draw_p": 110000,
    "possible_ambit": 2,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 6,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "unguidedWeaponry",
    "secondary_weapon_control": "unguided",
    "secondary_weapon_charge": 3,
    "secondary_weapon_ambits": 8,
    "secondary_weapon_targets": 1,
    "secondary_weapon_shots": 1,
    "secondary_weapon_damage": 2,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 1,
    "secondary_weapon_shot_success_rate_denominator": 1,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "signalJamming",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 2,
    "guided_defensive_success_rate_denominator": 3,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"water\"]",
    "class": "Cruiser",
    "class_abbreviation": "Cruiser",
    "default_cosmetic_model_number": "HD-44",
    "default_cosmetic_name": "Hydra",
    "build_draw": 110,
    "passive_draw": 110,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"land\", \"water\"]",
    "secondary_weapon_ambits_array": "[\"air\"]",
    "unit_description": "",
    "primary_weapon_label": "Planetary Missile",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "AA-Cannons",
    "secondary_weapon_class": "Ballistic Weapon",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Signal Jamming",
    "unit_defenses_description": "Has a 1/3 chance to deflect incoming Smart Weapon attacks.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 12,
    "type": "Destroyer",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 600,
    "build_draw_p": 100000,
    "max_health": 3,
    "passive_draw_p": 100000,
    "possible_ambit": 2,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 10,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "advancedCounterAttack",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 1,
    "counter_attack_same_ambit": 2,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"water\"]",
    "class": "Destroyer",
    "class_abbreviation": "Destroyer",
    "default_cosmetic_model_number": "KR-3",
    "default_cosmetic_name": "Kraken",
    "build_draw": 100,
    "passive_draw": 100,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"air\", \"water\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "05-SPRY Missile",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Adv. Counter-Attack",
    "passive_weaponry_description": "Deals extra DMG to Structs in the same battleground.",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 13,
    "type": "Submersible",
    "category": "fleet",
    "build_limit": 0,
    "build_difficulty": 455,
    "build_draw_p": 125000,
    "max_health": 3,
    "passive_draw_p": 125000,
    "possible_ambit": 2,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "guidedWeaponry",
    "primary_weapon_control": "guided",
    "primary_weapon_charge": 5,
    "primary_weapon_ambits": 18,
    "primary_weapon_targets": 1,
    "primary_weapon_shots": 1,
    "primary_weapon_damage": 2,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 1,
    "primary_weapon_shot_success_rate_denominator": 1,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "counterAttack",
    "unit_defenses": "stealthMode",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 2,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": true,
    "counter_attack": 1,
    "counter_attack_same_ambit": 1,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T17:58:34.416696+00:00",
    "possible_ambit_array": "[\"water\"]",
    "class": "Submersible",
    "class_abbreviation": "Submersible",
    "default_cosmetic_model_number": "LV-2",
    "default_cosmetic_name": "Leviathan",
    "build_draw": 125,
    "passive_draw": 125,
    "is_command": false,
    "primary_weapon_ambits_array": "[\"space\", \"water\"]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "",
    "primary_weapon_label": "Voidreach Missile",
    "primary_weapon_description": "",
    "primary_weapon_class": "Smart Weapon",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "Counter-Attack",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Stealth Mode",
    "unit_defenses_description": "When active, this Struct can only be targeted by units in the same battleground.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": true
  },
  {
    "id": 14,
    "type": "Ore Extractor",
    "category": "planet",
    "build_limit": 1,
    "build_difficulty": 10,
    "build_draw_p": 500000,
    "max_health": 6,
    "passive_draw_p": 500000,
    "possible_ambit": 6,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "oreMiningRig",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 14000,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"land\", \"water\"]",
    "class": "Ore Extractor",
    "class_abbreviation": "Extractor",
    "default_cosmetic_model_number": "LS-0",
    "default_cosmetic_name": "Lasersword",
    "build_draw": 500,
    "passive_draw": 500,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Extracts Alpha Ore from the planet.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  },
  {
    "id": 15,
    "type": "Ore Refinery",
    "category": "planet",
    "build_limit": 1,
    "build_difficulty": 700,
    "build_draw_p": 500000,
    "max_health": 6,
    "passive_draw_p": 500000,
    "possible_ambit": 6,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "oreRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 28000,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"land\", \"water\"]",
    "class": "Ore Refinery",
    "class_abbreviation": "Refinery",
    "default_cosmetic_model_number": "GR-3",
    "default_cosmetic_name": "Greybox",
    "build_draw": 500,
    "passive_draw": 500,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Refines Ore into usable Alpha Matter.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  },
  {
    "id": 16,
    "type": "Orbital Shield Generator",
    "category": "planet",
    "build_limit": 0,
    "build_difficulty": 720,
    "build_draw_p": 200000,
    "max_health": 6,
    "passive_draw_p": 200000,
    "possible_ambit": 16,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "monitoringStation",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 25,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"space\"]",
    "class": "Orbital Shield Generator",
    "class_abbreviation": "Orb. Shield",
    "default_cosmetic_model_number": "T70",
    "default_cosmetic_name": "Shieldwall",
    "build_draw": 200,
    "passive_draw": 200,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Improves Planetary Defense.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "Ore Shield",
    "ore_reserve_defenses_description": "Projects a shield around Ore storage facilities, improving Planetary Defense.",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  },
  {
    "id": 17,
    "type": "Jamming Satellite",
    "category": "planet",
    "build_limit": 1,
    "build_difficulty": 2880,
    "build_draw_p": 600000,
    "max_health": 6,
    "passive_draw_p": 600000,
    "possible_ambit": 16,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "coordinatedReserveResponseTracker",
    "planetary_defenses": "lowOrbitBallisticInterceptorNetwork",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 12,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"space\"]",
    "class": "Jamming Satellite",
    "class_abbreviation": "Jamming Sat.",
    "default_cosmetic_model_number": "OB-6",
    "default_cosmetic_name": "Observer",
    "build_draw": 600,
    "passive_draw": 600,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Applies Signal Jamming to all enemy Smart Weapon Attacks.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "Ore Surveillance",
    "ore_reserve_defenses_description": "Automated surveillance technologies improve Planetary Defense.",
    "planetary_defenses_label": "Planetary Signal Jamming",
    "planetary_defenses_description": "Has a 1/3 chance to deflect all enemy Smart Weapon attacks.",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  },
  {
    "id": 18,
    "type": "Ore Bunker",
    "category": "planet",
    "build_limit": 0,
    "build_difficulty": 3600,
    "build_draw_p": 750000,
    "max_health": 6,
    "passive_draw_p": 750000,
    "possible_ambit": 4,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "oreBunker",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 50,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"land\"]",
    "class": "Ore Bunker",
    "class_abbreviation": "Ore Bunker",
    "default_cosmetic_model_number": "HS-99",
    "default_cosmetic_name": "Hardshell",
    "build_draw": 750,
    "passive_draw": 750,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Massively improves Planetary Defense by storing Ore underground.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "Fortified Storage",
    "ore_reserve_defenses_description": "Ore is stored in a fortified underground facility.",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  },
  {
    "id": 19,
    "type": "Planetary Defense Cannon",
    "category": "planet",
    "build_limit": 1,
    "build_difficulty": 2880,
    "build_draw_p": 600000,
    "max_health": 6,
    "passive_draw_p": 600000,
    "possible_ambit": 6,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "noUnitDefenses",
    "ore_reserve_defenses": "coordinatedReserveResponseTracker",
    "planetary_defenses": "defensiveCannon",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "noPowerGeneration",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 0,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 0,
    "planetary_shield_contribution": 13,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"land\", \"water\"]",
    "class": "Planetary Defense Cannon",
    "class_abbreviation": "PDC",
    "default_cosmetic_model_number": "LK-7",
    "default_cosmetic_name": "Lookout",
    "build_draw": 600,
    "passive_draw": 600,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Launches Counter-Attacks against attacking Structs.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "",
    "unit_defenses_description": "",
    "ore_reserve_defenses_label": "Planetary Deterrent",
    "ore_reserve_defenses_description": "Mass accelerators intimidate pirates.",
    "planetary_defenses_label": "Planetary Overwatch",
    "planetary_defenses_description": "Launches Counter-Attacks against attacking Structs.",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 0,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  },
  {
    "id": 20,
    "type": "Field Generator",
    "category": "planet",
    "build_limit": 1,
    "build_difficulty": 700,
    "build_draw_p": 500000,
    "max_health": 8,
    "passive_draw_p": 500000,
    "possible_ambit": 6,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "armour",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "smallGenerator",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 1,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 2,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"land\", \"water\"]",
    "class": "Field Generator",
    "class_abbreviation": "Generator",
    "default_cosmetic_model_number": "MG-4",
    "default_cosmetic_name": "Magenta",
    "build_draw": 500,
    "passive_draw": 500,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Consumes Alpha Matter to generate Energy. Moderate efficiency.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Ablative Armour",
    "unit_defenses_description": "Reduces direct attack DMG by 1.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 2000,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  },
  {
    "id": 21,
    "type": "Continental Power Plant",
    "category": "planet",
    "build_limit": 1,
    "build_difficulty": 1440,
    "build_draw_p": 10000000,
    "max_health": 10,
    "passive_draw_p": 10000000,
    "possible_ambit": 6,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "armour",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "mediumGenerator",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 1,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 5,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"land\", \"water\"]",
    "class": "Continental Power Plant",
    "class_abbreviation": "Power Plant",
    "default_cosmetic_model_number": "HS-5",
    "default_cosmetic_name": "Homestead",
    "build_draw": 10000,
    "passive_draw": 10000,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Consumes Alpha Matter to generate Energy. High efficiency.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Ablative Armour",
    "unit_defenses_description": "Reduces direct attack DMG by 1.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 5000,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  },
  {
    "id": 22,
    "type": "World Engine",
    "category": "planet",
    "build_limit": 1,
    "build_difficulty": 5000,
    "build_draw_p": 100000000,
    "max_health": 10,
    "passive_draw_p": 100000000,
    "possible_ambit": 6,
    "movable": false,
    "slot_bound": true,
    "primary_weapon": "noActiveWeaponry",
    "primary_weapon_control": "noWeaponControl",
    "primary_weapon_charge": 0,
    "primary_weapon_ambits": 0,
    "primary_weapon_targets": 0,
    "primary_weapon_shots": 0,
    "primary_weapon_damage": 0,
    "primary_weapon_blockable": true,
    "primary_weapon_counterable": true,
    "primary_weapon_recoil_damage": 0,
    "primary_weapon_shot_success_rate_numerator": 0,
    "primary_weapon_shot_success_rate_denominator": 0,
    "secondary_weapon": "noActiveWeaponry",
    "secondary_weapon_control": "noWeaponControl",
    "secondary_weapon_charge": 0,
    "secondary_weapon_ambits": 0,
    "secondary_weapon_targets": 0,
    "secondary_weapon_shots": 0,
    "secondary_weapon_damage": 0,
    "secondary_weapon_blockable": true,
    "secondary_weapon_counterable": true,
    "secondary_weapon_recoil_damage": 0,
    "secondary_weapon_shot_success_rate_numerator": 0,
    "secondary_weapon_shot_success_rate_denominator": 0,
    "passive_weaponry": "noPassiveWeaponry",
    "unit_defenses": "armour",
    "ore_reserve_defenses": "noOreReserveDefenses",
    "planetary_defenses": "noPlanetaryDefense",
    "planetary_mining": "noPlanetaryMining",
    "planetary_refinery": "noPlanetaryRefinery",
    "power_generation": "largeGenerator",
    "activate_charge": 2,
    "build_charge": 1,
    "defend_change_charge": 1,
    "move_charge": 0,
    "stealth_activate_charge": 0,
    "attack_reduction": 1,
    "attack_counterable": true,
    "stealth_systems": false,
    "counter_attack": 0,
    "counter_attack_same_ambit": 0,
    "post_destruction_damage": 0,
    "generating_rate_p": 10,
    "planetary_shield_contribution": 0,
    "ore_mining_difficulty": 0,
    "ore_refining_difficulty": 0,
    "unguided_defensive_success_rate_numerator": 0,
    "unguided_defensive_success_rate_denominator": 0,
    "guided_defensive_success_rate_numerator": 0,
    "guided_defensive_success_rate_denominator": 0,
    "trigger_raid_defeat_by_destruction": false,
    "updated_at": "2026-09-24T16:33:27.930777+00:00",
    "possible_ambit_array": "[\"land\", \"water\"]",
    "class": "World Engine",
    "class_abbreviation": "World Engine",
    "default_cosmetic_model_number": "CS-8",
    "default_cosmetic_name": "Constellation",
    "build_draw": 100000,
    "passive_draw": 100000,
    "is_command": false,
    "primary_weapon_ambits_array": "[]",
    "secondary_weapon_ambits_array": "[]",
    "unit_description": "Consumes Alpha Matter to generate Energy. Extra high efficiency.",
    "primary_weapon_label": "",
    "primary_weapon_description": "",
    "primary_weapon_class": "",
    "secondary_weapon_label": "",
    "secondary_weapon_class": "",
    "drive_label": "",
    "drive_description": "",
    "passive_weaponry_label": "",
    "passive_weaponry_description": "",
    "unit_defenses_label": "Ablative Armour",
    "unit_defenses_description": "Reduces direct attack DMG by 1.",
    "ore_reserve_defenses_label": "",
    "ore_reserve_defenses_description": "",
    "planetary_defenses_label": "",
    "planetary_defenses_description": "",
    "planetary_mining_label": "",
    "planetary_mining_description": "",
    "planetary_refineries_label": "",
    "planetary_refineries_description": "",
    "power_generation_label": "",
    "power_generation_description": "",
    "generating_rate": 10000,
    "primary_weapon_armour_piercing": false,
    "secondary_weapon_armour_piercing": false,
    "can_defend": false
  }
];
